module.exports = __webpack_public_path__ + "static/media/mothers-day.2a7e521d.mp3";